import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WA_NUMBER = "919844139333";
const DEFAULT_MSG =
  "Hi Diplomexa, I'd like to learn more about Diplomexa for my conference.";

export default function WhatsAppFloating() {
  const [open, setOpen] = useState(false);
  const link = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  return (
    <>
      {open && (
        <div
          className="fixed bottom-24 right-5 z-[60] w-72 sm:w-80 rounded-2xl shadow-2xl border border-emerald-200 bg-white overflow-hidden animate-in fade-in slide-in-from-bottom-2"
          data-testid="whatsapp-popover"
        >
          <div className="bg-emerald-600 text-white px-4 py-3 flex items-center justify-between">
            <div>
              <p className="text-[10px] uppercase tracking-[0.18em] font-bold opacity-80">Live support</p>
              <p className="text-sm font-semibold">Chat with Diplomexa</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="h-7 w-7 rounded-full hover:bg-white/10 flex items-center justify-center"
              aria-label="Close"
              data-testid="whatsapp-popover-close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="p-4 space-y-3 text-sm">
            <p className="text-slate-700 leading-relaxed">
              Hello there 👋 — our team usually replies within an hour during 9 AM – 9 PM IST. Tap below to start a WhatsApp chat.
            </p>
            <div className="rounded-lg bg-emerald-50 border border-emerald-100 p-3">
              <p className="text-xs text-slate-500">Live agent</p>
              <p className="text-sm font-semibold text-[#0A192F]">+91 98441 39333</p>
            </div>
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="block w-full text-center px-4 py-2.5 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold uppercase tracking-[0.18em]"
              data-testid="whatsapp-popover-cta"
            >
              Open WhatsApp →
            </a>
            <p className="text-[10px] text-slate-400 text-center">
              Powered by Diplomexa · End-to-end encrypted
            </p>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-5 z-[60] h-14 w-14 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-2xl flex items-center justify-center transition-all hover:scale-105 ring-4 ring-emerald-100"
        data-testid="whatsapp-floating-button"
        aria-label="Chat with us on WhatsApp"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </>
  );
}
